import { AxiosService } from '@/shared/utils'
import { AxiosRequestConfig } from 'axios'
import {
  Cfe,
  RecommendationsType,
  SendReportToTelegramBot,
} from '@/shared/types'

class ReportApi extends AxiosService implements SendReportToTelegramBot {
  constructor(config?: AxiosRequestConfig) {
    super(config)
  }

  public getReportList(patientId: number) {
    return this.axiosCall({
      method: 'get',
      url: '/api/web/admin/reports/report-list',
      params: {
        patient_id: patientId,
      },
    })
  }

  public getReport(reportId: number) {
    return this.axiosCall({
      method: 'get',
      url: '/api/web/admin/reports/report',
      params: {
        report_id: reportId,
      },
    })
  }

  public getReportsWithoutPatient(reportId: string = undefined) {
    return this.axiosCall({
      method: 'get',
      url: '/api/web/admin/reports/null-patient',
      params: {
        report_search: reportId,
      },
    })
  }

  public removeReport(reportId: number) {
    return this.axiosCall({
      method: 'delete',
      url: `/api/web/admin/reports/delete/${reportId}`,
    })
  }

  public updateRecommendations(recommendations: RecommendationsType) {
    const { reportId, consultation, reCleaning } = recommendations
    const consultation_ = consultation.map((value: string) =>
      value.replace(/([a-z])([A-Z])/g, '$1_$2').toLowerCase()
    )

    return this.axiosCall({
      method: 'post',
      url: '/api/web/admin/reports/update',
      data: {
        report_id: reportId,
        consultation: consultation_,
        re_cleaning: reCleaning,
      },
    })
  }

  public updateCfeValues(reportId: number, cfeValues: Cfe) {
    const { caries, filling, extracted } = cfeValues

    return this.axiosCall({
      method: 'post',
      url: '/api/web/admin/reports/update-cfe',
      params: {
        report_id: reportId,
        caries,
        filling,
        extracted,
      },
    })
  }

  public sendEmail(reportId: number, sendCommentFiles: boolean) {
    return this.axiosCall({
      method: 'post',
      url: '/api/web/admin/reports/send-email',
      params: {
        report_id: reportId,
        send_comment_files: sendCommentFiles,
      },
    })
  }

  public sendReportToTelegramBot(reportId: number) {
    return this.axiosCall({
      method: 'post',
      url: `/api/web/admin/reports/telegram/${reportId}`,
    })
  }

  public getQRCodeForLinkPatient(reportId: number) {
    return this.axiosCall({
      method: 'get',
      url: `/api/web/admin/reports/${reportId}/get-qr`,
    })
  }

  public getStoneData() {
    return this.axiosCall({
      method: 'get',
      url: '/api/web/admin/reports/get-constants',
    })
  }

  public rotateImage(imageId: number) {
    return this.axiosCall({
      method: 'post',
      url: `/api/web/admin/reports/rotate-image/${imageId}`,
    })
  }

  public downloadPdf(reportId: number) {
    return this.axiosCall({
      method: 'get',
      url: `/api/web/admin/reports/report/download-from-service/${reportId}`,
      responseType: 'blob',
    })
  }
}

export const reportApi = new ReportApi({
  baseURL:
    process.env.NODE_ENV === 'production' ? process.env.VUE_APP_BASE_URI : '',
  withCredentials: true,
})
